import { render, staticRenderFns } from "./VendorShipAddNew.vue?vue&type=template&id=54c53500"
import script from "./VendorShipAddNew.vue?vue&type=script&lang=js"
export * from "./VendorShipAddNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports